<template>
    <div>
    <div class="air__utils__heading">
      <h3>Content Cards</h3>
    </div>
    <div class="row">
      <div class="col-lg-12 text-right">
          <a-button type="primary" class="float-right" @click="showDrawer({})">Crear</a-button> <br> <br>
      </div>
    </div>
    <a-drawer
      :title="titleDetail"
      placement="right"
      :closable="false"
      @close="onClose"
      :visible="itemDetailShow"
      width=740>

      <ItemDetail :content.sync="content" :isUpdated="isUpdated" closable="true" v-on:closeDetail="onClose($event)" v-on:updateProfiles="update()"/>

    </a-drawer>
  </div>
</template>

<script>
import ItemDetail from './widgets/itemDetail'
export default {
  components: {
    ItemDetail,
  },
  data () {
    return {
     itemDetailShow: false,
     content: {},
    }
  },
  created() {
    // this.fetch()
  },
  methods: {
    showDrawer(content) {
      this.content = content
      this.itemDetailShow = true
    },
    onClose($event) {
      this.itemDetailShow = false;
    },
    onSelect(record, selected, selectedRows, nativeEvent) {
      console.log(selected[0])
      this.showDrawer(selected[0])
    },
    update(){
      console.log("UPDATE");
      this.$emit('update', true)
    }
  },
  computed: {
    titleDetail: function() {
      return this.isUpdated ? ('Configuración de Perfil: ' + this.content.namePerfil) : 'Nuevo'
    },
    isUpdated: function () {
      return this.content.hasOwnProperty('namePerfil')
    },
  }
}
</script>